import { render, staticRenderFns } from "./AlbumAdminToken.vue?vue&type=template&id=1cb21e88&"
import script from "./AlbumAdminToken.vue?vue&type=script&lang=js&"
export * from "./AlbumAdminToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports